module.exports = __webpack_public_path__ + "media/1923-1893.17e34e26.mp4";